import { useState } from 'react';
import dayjs from 'dayjs';
import { useBackgroundSync } from '@/context/BackgroundSyncContext';
import ConnectivityIndicator from '@/common/ConnectivityIndicator';
import SyncIndicator from '@/common/SyncIndicator/SyncIndicator';
import useOnlineStatus from '@/hooks/useOnlineStatus';
import MenuIcon from '@/assets/icons/menu.svg?react';
import SidebarMenu from './SidebarMenu';
import styles from './Navbar.module.scss';

interface TourBagNavbarProps {
  title: string;
  children: React.ReactNode;
}

export default function Navbar({ title, children }: TourBagNavbarProps) {
  const isOnline = useOnlineStatus();
  const { lastSyncDate } = useBackgroundSync();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className={styles.tourBagNavbar}>
      <div id="btnTouringNavMain" className={styles.menuWrapper} onClick={() => setIsMenuOpen(!isMenuOpen)} role="button">
        <MenuIcon />
        <h1 className={styles.pageTitle}>{title}</h1>
        <span className={styles.onlineStatus}>
          <ConnectivityIndicator /> {!isOnline && <div className={styles.lastSync}>Last sync: {dayjs(lastSyncDate).format('MM/DD HH:mm')}</div>}
        </span>
        <SyncIndicator className={styles.syncIndicator} />
      </div>
      {children}
      <SidebarMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </header>
  );
}
